<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-text.px-6.py-8
          div.h5.mb-4.danger500--text.text-capitalize.text-center {{ $t('low_balance') }}
          div.p1.mb-8.primary500--text.text-center {{ $t('you_have_insufficient') }}
          div.c2.mb-6.primary500--text.text-center {{ $t('amount_needed') }}: {{ amount | displayPrice }}
          v-card-actions.text-center(style="display: grid")
            v-btn.mx-auto(
              @click="showCreditReloadDialog = true; showModal = false",
              height="32",
              style="background-color: var(--v-infoT08)", 
              color="info500"
            )
              .button-AA-small.basic100--text {{ $t('reload') }}
            v-btn.mx-auto(
              @click="showModal = !showModal",
              text,
              depressed,
              height="32",
            )
              .button-Aa-small.primary400--text {{ $t('cancel') }}
    .modals
      credit-reload(v-if="showCreditReloadDialog" :open.sync="showCreditReloadDialog")
</template>

<script>
import CreditReload from '@/components/yezzabook/dialogs/CreditReload.vue'

export default {
  name: 'LowBalance',
  components: {CreditReload},
  props: ['open', 'amount'],
  data: () => ({
    showCreditReloadDialog: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "you_have_insufficient": "You have insufficient credit to perform this transaction. Please reload to proceed."
  }
}
</i18n>
